<template>
  <div :class="{ 'has-logo': showLogo }">
    <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
    <div
      style="width: 100%; height: 50px; margin-top: 3px; cursor: pointer;"
      @click="toDashboard()"
    >
      <img
        src="@/icons/logo.png"
        style="zoom: 0.82;
    margin-top: 8px;
    margin-left: 16px;"
      />
    </div>

    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- default-openeds 导航栏默认展开 -->
      <el-menu
        :default-active="$route.path"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        :default-openeds="[
          '/businessManagement',
          '/appCenter',
          '/SecurityAudit',
          '/hotel',
          '/operation',
          '/system',
          '/systemHotel',
          '/hotelAnalysis',
          '/operationLog',
          '/revenue',
          '/productIntroduction'
        ]"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  data() {
    return {
      deOption: []
    };
  },
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(["sidebar"]),
    menutree() {
      try {
        const data = localStorage.getItem("menutree");
        return data ? JSON.parse(data) : [];
      } catch (e) {
        return [];
      }
    },
    permissionRoutes() {
      const routes = this.$router.options.routes;
      if (!this.menutree || this.menutree.length === 0) {
        return routes;
      }

      const menuPermissions = {};
      this.menutree.forEach(menu => {
        const parentName = menu.menu_uri_name;
        if (parentName) {
          menuPermissions[parentName] = true;
        }
        if (menu.children && menu.children.length > 0) {
          menu.children.forEach(child => {
            const childName = child.menu_uri_name;
            if (childName) {
              menuPermissions[childName] = true;
            }
          });
        }
      });

      return routes
        .map(route => {
          if (!route.children || route.children.length === 0) {
            return route;
          }

          const filteredChildren = route.children.filter(child => {
            if (child.hidden) return true;
            if (!child.name) return false;
            return menuPermissions[child.name] === true;
          });

          if (filteredChildren.length === 0) {
            return null;
          }

          return {
            ...route,
            children: filteredChildren
          };
        })
        .filter(route => route !== null);
    },
    routes() {
      return this.permissionRoutes;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },

  methods: {
    toDashboard() {
      this.$router.push({ path: "/dashboard" });
    }
  }

  // created () {
  //   // JSON.parse(localStorage.getItem('deOption'))
  //   if (localStorage.getItem('deOption') != null || localStorage.getItem('deOption') != '') {
  //     this.deOption = JSON.parse(localStorage.getItem('deOption'))
  //     console.log('数组:', this.deOption)
  //   } else {
  //     this.deOption = []
  //   }
  // },

  // mounted() {
  //   if (localStorage.getItem('deOption') != null || localStorage.getItem('deOption') != '') {
  //     this.deOption = JSON.parse(localStorage.getItem('deOption'))
  //     console.log('数组:', this.deOption)
  //   } else {
  //     this.deOption = []
  //   }
  // },

  // methods: {
  //   handleOpen (key, keyPath) {
  //     console.log(key, keyPath);
  //     this.deOption = this.deOption.concat()
  //     console.log('默认展开菜单:', this.deOption)
  //     localStorage.setItem('deOption', JSON.stringify(this.deOption))
  //   },
  //   handleClose (key, keyPath) {
  //     console.log(key, keyPath);
  //     console.log('默认关闭菜单:', this.deOption)
  //     localStorage.setItem('deOption', JSON.stringify(this.deOption))
  //   }
  // }
};
</script>
